import { $host } from '@App/api'
import { getDataWrapper } from '@App/api/helper'
import requestByFilters, { ParamsByFilter } from '@App/helpers/requestByFilters'

export const getTransactionHistoryDetails = async (filters: ParamsByFilter[] = []) => {
  const filterString = filters.length ? `?${requestByFilters(filters)}` : ''

  return await getDataWrapper($host.get(`api/me/transactions${filterString}`))
}
